// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2936":"6c7b3e7f","3715":"8ace9899","4103":"8ace9899","8822":"d10c5ccb"}[chunkId] + ".chunk.css";
};